import i18n from 'config/i18n';
import * as yup from 'yup';

import { nanToDefaultNull } from './utils';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale());

export const schema = yup.object({
  claCode: yup.string(),
  claId: yup.number().required(t('ageHours.errors.claCodeRequired')),
  yearValid: yup
    .number()
    .required(t('ageHours.errors.yearValidRequired'))
    .min(
      1900,
      t('validationMinNumber', {
        name: t('ageHours.grid.yearValid'),
        number: 1900
      })
    )
    .max(
      2100,
      t('validationMaxNumber', {
        name: t('ageHours.grid.yearValid'),
        number: 2100
      })
    )
    .typeError(t('ageHours.errors.yearValidRequired')),
  ageYear: yup
    .number()
    .required(t('ageHours.errors.ageYearRequired'))
    .min(
      0,
      t('validationMinNumber', { name: t('ageHours.grid.ageYear'), number: 0 })
    )
    .max(
      100,
      t('validationMaxNumber', {
        name: t('ageHours.grid.ageYear'),
        number: 100
      })
    )
    .typeError(t('ageHours.errors.ageYearRequired')),
  startHours: yup.number().default(0).nullable().transform(nanToDefaultNull),
  hours: yup.number().default(0).nullable().transform(nanToDefaultNull),
  startHoursPlb: yup.number().default(0).nullable().transform(nanToDefaultNull),
  hoursPlb: yup.number().default(0).nullable().transform(nanToDefaultNull)
});
